<template>
  <div class="author-mine-bg">
    <div class="author-mine">
      <div class="am-container">
        <div class="c-author-header">
          <AuthorInfoHeader></AuthorInfoHeader>
        </div>
        <div class="am-content">
          <div class="c-content-tab">
            <ContentLeftTab
              v-bind:tabData="leftTabData"
              v-bind:selectedTab="leftTabSelected"
              @TabChange="TabChange"
            ></ContentLeftTab>
          </div>
          <div class="am-content-swap">
            <div class="cmc-header">
              <span class="cmd-header-text">{{ contentTitle }}</span>
              <div class="cmd-header-line"></div>
            </div>
            <div>
              <!-- 内容组件 -->
              <div v-if="leftTabSelected === 1" class="c-author-info-content">
                <Profit></Profit>
              </div>
              <div
                v-else-if="leftTabSelected === 3"
                class="c-author-info-content"
              >
                <PassWordChanging></PassWordChanging>
              </div>
              <!-- start leftTabSelected === 2 -->
              <div v-else-if="!isEditing" class="c-author-info-content">
                <AuthorInfoContent
                  v-bind:post="detailPost"
                  v-on:submit="contentSubmit"
                ></AuthorInfoContent>
              </div>
              <div v-else class="c-author-info-content">
                <Successed
                  @SuccSubmit="SuccSubmit"
                  v-bind:post="{
                    text: isAuditing ? '提交申请成功' : '申请失败',
                    btnText: '重新提交',
                    notify: isAuditing
                      ? [
                          '工作人员将在3个工作日内通知您﹐请耐心等待',
                          '客服电话:4006060101转2'
                        ]
                      : [
                          '认证资料不足，请重新填写资料后提交，有问题请拨打',
                          '客服电话:4006060101转2'
                        ],
                    btnShow: !isAuditing,
                    success: isAuditing
                  }"
                ></Successed>
              </div>
              <!-- end leftTabSelected === 2 -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthorInfoHeader from '@/components/AuthorInfoHeader'
import ContentLeftTab from '@/components/ContentLeftTab'
import AuthorInfoContent from '@/components/AuthorInfoContent'
import Profit from '@/components/Profit'
import PassWordChanging from '@/components/PassWord/PassWordChanging'
import Successed from '@/components/Successed'
import { upsertAuthor } from '@/api/author'

export default {
  name: 'AuthorMine',
  components: {
    AuthorInfoHeader,
    ContentLeftTab,
    AuthorInfoContent,
    Profit,
    PassWordChanging,
    Successed
  },
  data() {
    return {
      tableTab: 'qdPass',
      isPassWordLogin: true,
      leftTabData: [
        {
          id: 1,
          name: '我的营收',
          comp: 'Profit'
        },
        {
          id: 2,
          name: '个人资料',
          comp: 'AuthorInfoContent'
        },
        {
          id: 3,
          name: '修改密码',
          comp: 'PassWordChanging'
        }
      ],
      leftTabSelected: 1,
      contentTitle: '',
      contentComp: '',
      isEditing: false,
      isAuditing: false
    }
  },
  created() {
    var initTab = this.leftTabData.filter(x => x.id === this.leftTabSelected)[0]
    this.contentTitle = initTab.name
    this.contentComp = initTab.comp
    this.isEditing = this.$store.getters['user/isEditing']
  },
  computed: {
    detailPost() {
      return {
        state: 1,
        btnText: '提交'
      }
    }
  },
  methods: {
    async TabChange(tabItem) {
      if (tabItem.id === 2) {
        // 刷新大咖资料
        await this.$store.dispatch('user/getAuthorInfo')
        this.setAuthorStatus()
      }
      this.contentTitle = tabItem.name
      this.leftTabSelected = tabItem.id
    },
    setAuthorStatus() {
      // 是否资料编辑中
      this.isEditing = this.$store.getters['user/isEditing']
      // 是否审核中
      this.isAuditing = this.$store.state.user.authorInfo.checkstatus === 0
    },
    // 大咖提交资料
    async contentSubmit(info) {
      console.log('大咖提交资料 info:', info)
      var data = {}
      Object.assign(data, info)
      data.mobilephone = this.$store.state.auth.loginInfo.mobile

      // 校验擅长、能力、简介
      if (!this.validatePerfectInfo(data)) {
        return false
      }
      const { result } = await upsertAuthor(data).catch(data => {
        console.log('upsertAuthor error:', data)
        this.showError()
      })
      if (result.code === 0) {
        // 提交成功
        this.isEditing = true
        this.isAuditing = true
        // 刷新大咖信息
        this.$store.dispatch('user/getAuthorInfo')
      } else if (result.code === 22206) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    validatePerfectInfo(data) {
      return (
        data.tagexpert &&
        data.tagskill &&
        data.remark &&
        data.tagexpert.length > 0 &&
        data.tagskill.length > 0 &&
        data.remark
      )
    },
    SuccSubmit() {
      this.isEditing = true
    }
  }
}
</script>
<style lang="scss" scoped>
.author-mine-bg {
  background-color: #f0f0f0;
}
.author-mine {
  // padding-top: 100px;
  width: 1200px;
  margin: 0 auto;
  .am-container {
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    .c-content-header {
      margin: 0 100px;
    }
    .am-content {
      display: flex;
      .c-content-tab {
        margin-top: 20px;
      }
      .am-content-swap {
        margin: 20px 0 0 20px;
        width: 865px;
        height: auto;
        min-height: 495px;
        background-color: #ffffff;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        .cmc-header {
          margin-top: 25px;
          height: 45px;
          padding: 0 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .cmd-header-line {
            width: 100%;
            height: 1px;
            background-color: #ebebeb;
          }
          .cmd-header-text {
            font-family: MicrosoftYaHei;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 0px;
            color: #262626;
          }
        }
        .c-author-info-content {
          margin: 25px 50px;
          min-height: 300px;
        }
      }
    }
  }
}
</style>
